// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"df40456bfa3213a63f8b","339":"8239f37515825dae254b"}[chunkId] + ".js";
};